var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list.length)?_c('CMultiSelect',{attrs:{"multiple":true,"search":true,"optionsEmptyPlaceholder":"No options placeholder","searchPlaceholder":_vm.$t('Select'),"selected":[],"selection":true,"selectionTypeCounterText":_vm.$t('type(s) selected'),"options":_vm.list},on:{"update":_vm.select}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }